var map = {
	"./RFID.png": "e532",
	"./battery_swap_in_progress.svg": "c282",
	"./battery_swap_required.svg": "7d1a",
	"./cancel.svg": "9fc5",
	"./docked_charging_adapter.svg": "bae9",
	"./inactive.svg": "b15f",
	"./inside_of_service_area.svg": "7620",
	"./inspection_required.svg": "3691",
	"./none.png": "991f",
	"./ok.png": "9cee",
	"./on-charging-pick.png": "1d7c",
	"./on-charging-pick.svg": "1068",
	"./on-charging.png": "493c",
	"./on-charging.svg": "1931",
	"./on-geofence-fault.png": "1201",
	"./on-geofence-fault.svg": "31e3",
	"./on-illegally-parked.svg": "bdaa",
	"./on-iot-fault.png": "00c5",
	"./on-iot-fault.svg": "1b14",
	"./on-low-battery.png": "5f9a",
	"./on-low-battery.svg": "e750",
	"./on-maintainance.png": "5b4d",
	"./on-maintainance.svg": "cecc",
	"./on-missing.png": "0f81",
	"./on-missing.svg": "52ab",
	"./on-parking.svg": "bc0e",
	"./on-rebalance.png": "1c97",
	"./on-rebalance.svg": "af89",
	"./on-reservation.png": "6d41",
	"./on-reservation.svg": "5a3f",
	"./on-ride.png": "5b42",
	"./on-ride.svg": "675d",
	"./outside_of_service_area.svg": "593d",
	"./pass_applied.svg": "511a",
	"./promo_applied.svg": "4c07",
	"./re_inspection.svg": "a827",
	"./refund.svg": "1029",
	"./repair_required.svg": "aa46",
	"./restricted_area.svg": "82eb",
	"./rfid-logo.png": "4af3",
	"./rider_balance_negative.svg": "565c",
	"./sleep_mode.svg": "6f66",
	"./slow_area.svg": "6cd3",
	"./swap-battery.svg": "474e",
	"./trigger_payment_applied.svg": "9234",
	"./trigger_payment_failed.svg": "e592",
	"./unavailable.svg": "3f51",
	"./vehicle-dark.svg": "2d6e",
	"./vehicle-light.svg": "0e0d",
	"./voucher_applied.svg": "09dd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1da8";